@import '../../style/index';

:host {
  display: block;
}
